import { Dialog, DialogTitle, DialogContent } from "@mui/material";

import { DialogProps } from "@toolpad/core/useDialogs";

import { DialogoBaseProps } from "@interfaces/components";
import { ActionIcon, ActionIconType } from "@components/ActionIcon";
import { ComentariosGenerales } from "@components/PopupSegmentos/ComentariosGenerales";

interface ComentariosGeneralesDialogProps extends DialogoBaseProps {}

/**
 * V2 del botón "Comentarios" en `@components/CustomHeader.tsx` — en vez del
 * `Popper` anclado de `PopupManager.tsx`, se abre como `Dialog` (mismo patrón
 * que `EdicionExpedientePersonaDialog.tsx`: `useDialogs()`/`DialogProps`).
 * Reusa `ComentariosGenerales` tal cual (feed de comentarios de toda la
 * solicitud, filtrado por permisos), que ya es un `Box` autocontenido sin
 * lógica de Popper.
 */
export const ComentariosGeneralesDialog = (props: DialogProps<ComentariosGeneralesDialogProps, void>) => {
    return (
        <Dialog
            fullWidth={props.payload.fullWidth ?? true}
            maxWidth={props.payload.maxWidth ?? "md"}
            open={props.open}
            scroll="paper"
        >
            <DialogTitle variant="h5" fontWeight={500} textAlign="center">
                Comentarios
                <ActionIcon
                    typeIcon={ActionIconType.CANCEL}
                    onClick={() => props.onClose?.()}
                    sx={{ position: "absolute", right: 0, top: 0 }}
                />
            </DialogTitle>
            <DialogContent>
                <ComentariosGenerales width="100%" />
            </DialogContent>
        </Dialog>
    );
};
